// DotDigital
/* eslint-disable */
if (!window.dmPt) {
    (function (w, d, u, t, o, c) {
        w["dmtrackingobjectname"] = o;
        c = d.createElement(t);
        c.async = 1;
        c.src = u;
        t = d.getElementsByTagName(t)[0];
        t.parentNode.insertBefore(c, t);
        w[o] =
            w[o] ||
            function () {
                (w[o].q = w[o].q || []).push(arguments);
            };
    })(window, document, "//static.trackedweb.net/js/_dmptv4.js", "script", "dmPt");
    window.dmPt("create", window.dotDigitalId);
    window.dmPt("track");
}
